// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_name_currency_symbol",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'it': 'it', 'en': 'en'},
        displayType: "language_code",
        fontColor: "#a38e5c",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "0.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "ip_base",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Italy", "code": "IT", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"Italiano": {"name": "Italiano (Italian)", "native_name": "Italiano", "code": "it", "default": true}, "English": {"name": "English", "native_name": "English", "code": "en", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        